(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var types = require('ast-types');

var def = types.Type.def;
var or = types.Type.or;

var BinaryAssignment = or(def('PBXIdentifier'), def('PBXLiteral'), def('PBXMemberExpression'), def('PBXUnarySignExpression'));

var BinaryOperator = or('==', '!=', '<', '<=', '>', '>=');

var ExpressionStatementAssignment = or(def('PBXBinaryExpression'), def('PBXFunctionExpression'), def('PBXIdentifier'), def('PBXLogicalAndExpression'), def('PBXLogicalOrExpression'), def('PBXLiteral'), def('PBXMemberExpression'), def('PBXUnaryFunctionExpression'), def('PBXUnaryNotExpression'), def('PBXUnarySignExpression'));

var FunctionAssignment = or(def('PBXIdentifier'), def('PBXLiteral'), def('PBXMemberExpression'), def('PBXUnarySignExpression'));

var FunctionOperator = or('CONTAINS', 'IN', 'STARTS_WITH', 'ENDS_WITH', 'IS_EMPTY');

var IdentifierName = or('fields', 'files', 'run', 'task', 'tasks', 'team');

var LiteralAssignment = or(Boolean, Number, String);

var LogicalAndAssignment = or(def('PBXBinaryExpression'), def('PBXFunctionExpression'), def('PBXIdentifier'), def('PBXLiteral'), def('PBXLogicalAndExpression'), def('PBXMemberExpression'), def('PBXUnaryFunctionExpression'), def('PBXUnaryNotExpression'), def('PBXUnarySignExpression'));

var LogicalAndOperator = '&&';

var LogicalOrLeftAssignment = or(def('PBXBinaryExpression'), def('PBXFunctionExpression'), def('PBXIdentifier'), def('PBXLiteral'), def('PBXUnaryFunctionExpression'), def('PBXLogicalAndExpression'), def('PBXLogicalOrExpression'), def('PBXMemberExpression'), def('PBXUnaryNotExpression'), def('PBXUnarySignExpression'));

var LogicalOrRightAssignment = or(def('PBXBinaryExpression'), def('PBXFunctionExpression'), def('PBXIdentifier'), def('PBXLiteral'), def('PBXUnaryFunctionExpression'), def('PBXLogicalAndExpression'), def('PBXMemberExpression'), def('PBXUnaryNotExpression'), def('PBXUnarySignExpression'));

var LogicalOrOperator = '||';

var MemberAssignment = or(def('PBXIdentifier'), def('PBXMemberExpression'));

var UnaryFunctionOperator = or('IS_EMPTY');

var UnaryFunctionAssignment = or(def('PBXIdentifier'), def('PBXLiteral'), def('PBXMemberExpression'));

var UnaryNotOperator = '!';

var UnaryNotAssignment = or(def('PBXFunctionExpression'), def('PBXUnaryFunctionExpression'));

var UnarySignAssignment = or(def('PBXIdentifier'), def('PBXLiteral'), def('PBXMemberExpression'));

var UnarySignOperator = or('+', '-');

def('PBXBinaryExpression').bases('BinaryExpression').build('operator', 'left', 'right').field('operator', BinaryOperator).field('left', BinaryAssignment).field('right', BinaryAssignment);

def('PBXExpressionStatement').bases('ExpressionStatement').build('expression').field('expression', ExpressionStatementAssignment);

def('PBXFunctionExpression').bases('LogicalExpression').build('operator', 'left', 'right').field('operator', FunctionOperator).field('left', FunctionAssignment).field('right', FunctionAssignment);

def('PBXIdentifier').bases('Identifier').build('name').field('name', IdentifierName);

def('PBXLiteral').bases('Literal').build('value').field('value', LiteralAssignment);

def('PBXLogicalAndExpression').bases('LogicalExpression').build('left', 'right').field('left', LogicalAndAssignment).field('right', LogicalAndAssignment).field('operator', LogicalAndOperator, function () {
  return LogicalAndOperator;
});

def('PBXLogicalOrExpression').bases('LogicalExpression').build('left', 'right').field('left', LogicalOrLeftAssignment).field('right', LogicalOrRightAssignment).field('operator', LogicalOrOperator, function () {
  return LogicalOrOperator;
});

def('PBXMemberExpression').bases('MemberExpression').build('object', 'property').field('object', MemberAssignment).field('property', def('PBXLiteral')).field('computed', true, function () {
  return true;
});

def('PBXProgram').bases('Program').build('body').field('body', def('PBXExpressionStatement'));

def('PBXUnaryFunctionExpression').bases('UnaryExpression').build('operator', 'argument').field('operator', UnaryFunctionOperator).field('argument', UnaryFunctionAssignment);

def('PBXUnaryNotExpression').bases('UnaryExpression').build('argument', 'operator').field('argument', UnaryNotAssignment).field('operator', UnaryNotOperator, function () {
  return UnaryNotOperator;
}).field('prefix', Boolean, function () {
  return true;
});

def('PBXUnarySignExpression').bases('UnaryExpression').build('operator', 'argument').field('operator', UnarySignOperator).field('argument', UnarySignAssignment).field('prefix', Boolean, function () {
  return true;
});

types.finalize();

module.exports = types;

})));
//# sourceMappingURL=types.js.map
